// extracted by mini-css-extract-plugin
export default {"picture":"ClosurePage_picture__FQ1qt"};